import { defineMessages } from 'react-intl'

export const exportDomainMessages = defineMessages({
  title: {
    id: 'exportDomain.title',
    description: 'A title of modal allowing to export Group/Domain',
    defaultMessage: 'Export {domainName}',
  },
  download: {
    id: 'exportDomain.download',
    description: 'A title of button to download export Group/Domain',
    defaultMessage: 'Download',
  },
})
